import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Button, Popover } from '@mui/material'
import MenuRoundedIcon from '@mui/icons-material/MenuRounded'
import clsx from 'clsx'
import items from './_headerNavigation.def'
import useStyles from './_styles'

const HeaderNavigationPopover = () => {
    const classes = useStyles()
    const location = useLocation()

    const [anchorEl, setAnchorEl] = React.useState(null)

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const open = Boolean(anchorEl)
    const id = open ? 'HeaderHcsSwitch-popover' : undefined

    return (
        <div className={classes.HeaderNavigationPopover}>
            <Button className={classes.HeaderNavigationPopoverButton} onClick={handleClick}>
                <MenuRoundedIcon />
            </Button>
            <Popover
                classes={{
                    paper: classes.HeaderNavigationPopoverPaper,
                }}
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <div className={classes.HeaderNavigationPopoverItems}>
                    {items.map((item) => (
                        <Link
                            className={clsx(
                                classes.HeaderNavigationPopoverItem,
                                location.pathname === item.to && classes.HeaderNavigationPopoverItemActive
                            )}
                            to={item.to}
                            key={item.label}
                            data-cy={item.dataCy}
                            onClick={handleClose}
                        >
                            {item.label}
                        </Link>
                    ))}
                </div>
            </Popover>
        </div>
    )
}

export default HeaderNavigationPopover
